










































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { APP_CONFIG } from '@/config/app-config';
import { DepositModel } from '@/models/deposit';
import commonService from '@/services/common-services';
import depositService from '@/services/deposit-services';
@Component
export default class CustomerInfo extends Vue {
    @Prop({default: null})
    private deposit!: DepositModel;
    zeroPad = (num, places) => String(num).padStart(places, '0');
    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }
    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    get chinaStore() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].chinaStore;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async getChinaStore() {
        const result = await commonService.getChinaStore();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CHINASTORE', result.data.data);
        }
    }

    get chinaStoreAddress() {
        if (this.customerInfo && this.customerInfo.ChinaStoreID && this.chinaStore) {
            const result = this.chinaStore.find(c => c.ID == this.customerInfo.ChinaStoreID);

            if (result) {
            return `${result.Receiver}${this.zeroPad(this.customerInfo.ID, 3)} - ${result.Phone} - ${result.Address}${this.zeroPad(this.customerInfo.ID, 3)}`;
            }
        }
        return '';
    }

    get safeLevelDesc() {
        if (this.deposit && this.safeLevels) {
            const result = this.safeLevels.find(c => c.ID == this.deposit.safeLevelID);

            if (result) {
            return result.Description;
            }
        }
        return '';
    }

    get safeLevels() {
        let tmp = this.$store.state[APP_CONFIG.stateKey.commonStore].safeLevel
        if (tmp != null) {
            tmp.unshift({ID: 0, Name: ''});
        }
        return tmp;
    }

    private async getSafeLevel() {
        const result = await commonService.getSafeLevelByStore(this.deposit.chinaStoreID);
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_SAFELEVEL', result.data.data);
        }
    }

    private async safeLevelChanged() {
        let payload = {SafeLevelID: this.deposit.safeLevelID};
        const result = await depositService.updateDeposit(this.deposit.id, payload);
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Cập nhật ký gửi thành công!',
            });
        } else if (result && result.data.status === 202) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: result.data.error,
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
        if (!this.chinaStore) {
            await this.getChinaStore();
        }
        if (!this.safeLevels) {
            await this.getSafeLevel();
        }
    }
}
